<template>
  <div class="p-6 ml-64 min-h-screen flex flex-col overflow-hidden">
    <SpinnerComp v-if="loading" :fullscreen="true" />
    <div v-else>
      <!-- Título -->
      <div>
        <h1
          class="text-[#1E5D22] font-semibold text-3xl font-sans mb-4 ml-8 mt-7"
        >
          Carrito
        </h1>
      </div>

      <div class="ml-8 mt-6 flex justify-between items-center w-[1160px]">
        <!-- Select de Unidad -->
        <div
          class="flex items-center bg-white border border-[#969292]/30 rounded-xl p-2 w-[550px]"
        >
          <label class="ml-3 text-[#817F7F] text-lg font-semibold"
            >Unidad:</label
          >
          <select
            v-model="selectedUnidad"
            class="ml-3 text-black text-lg bg-transparent focus:outline-none w-full"
          >
            <option value="" disabled>Selecciona una unidad</option>
            <option v-for="unidad in unidades" :key="unidad.id" :value="unidad">
              {{ unidad.name }}
            </option>
          </select>
        </div>

        <!-- Operador -->
        <div
          class="flex items-center bg-white border border-[#969292]/30 rounded-xl p-2 w-[550px]"
        >
          <label class="ml-3 text-[#817F7F] text-lg font-semibold"
            >Operador:</label
          >
          <div class="ml-3 text-black text-lg w-full">
            {{ selectedUnidad?.operador_name || "Sin operador" }}
          </div>
        </div>
      </div>

      <!-- Tabla carrito -->
      <div class="ml-8 mt-10 w-[1160px]">
        <div
          class="bg-white border border-[#969292]/30 rounded-2xl overflow-hidden"
        >
          <table class="w-full table-auto text-left">
            <thead>
              <tr>
                <th
                  class="py-4 px-12 font-semibold text-[#817F7F] text-lg text-left w-[300px]"
                >
                  Producto
                </th>
                <th
                  class="py-4 px-6 font-semibold text-[#817F7F] text-lg text-center w-[120px]"
                >
                  Precio
                </th>
                <th
                  class="py-4 px-6 font-semibold text-[#817F7F] text-lg text-center w-[150px]"
                >
                  Cantidad
                </th>
                <th
                  class="py-4 px-6 font-semibold text-[#817F7F] text-lg text-center w-[140px]"
                >
                  Total
                </th>
                <th
                  class="py-4 px-6 font-semibold text-[#817F7F] text-lg text-center w-[50px]"
                ></th>
              </tr>
              <tr>
                <td colspan="5">
                  <div
                    class="w-[95%] mx-auto border-b border-[#969292]/30"
                  ></div>
                </td>
              </tr>
            </thead>

            <tbody class="border-separate border-spacing-y-2">
              <tr
                v-for="(producto, index) in productosCarrito"
                :key="index"
                class="hover:bg-gray-50"
              >
                <!-- Producto -->
                <td class="flex items-center gap-4 py-4 px-12 w-[300px]">
                  <img
                    :src="producto.imagen"
                    alt="Producto"
                    class="w-12 h-12 rounded-md object-contain"
                  />
                  <span class="text-black font-medium text-lg">{{
                    producto.nombre
                  }}</span>
                </td>

                <!-- Precio -->
                <td class="text-black py-4 px-6 text-center text-lg w-[120px]">
                  ${{ producto.precio.toFixed(2) }}
                </td>

                <!-- Cantidad -->
                <td class="py-4 px-6 text-center w-[150px]">
                  <div class="flex items-center justify-center gap-3">
                    <button
                      @click="disminuirCantidad(index)"
                      class="w-7 h-7 rounded-full bg-green-600 text-white text-base leading-none font-bold flex items-center justify-center"
                    >
                      −
                    </button>
                    <input
                      type="number"
                      min="1"
                      :max="producto.stock"
                      v-model.number="producto.cantidad"
                      @change="validarCantidad(index)"
                    />

                    <button
                      @click="aumentarCantidad(index)"
                      class="w-7 h-7 rounded-full bg-green-600 text-white text-base leading-none font-bold flex items-center justify-center"
                    >
                      +
                    </button>
                  </div>
                </td>

                <!-- Total -->
                <td
                  class="text-green-700 font-semibold py-4 px-6 text-center text-lg w-[140px]"
                >
                  ${{ (producto.precio * producto.cantidad).toFixed(2) }}
                </td>

                <!-- Eliminar -->
                <td class="py-4 px-6 text-center w-[50px]">
                  <button @click="eliminarProducto(index)">
                    <svg
                      class="w-5 h-5 text-black hover:text-red-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="ml-8 mt-10 flex justify-between items-center w-[1160px] gap-4"
      >
        <!-- Total de productos -->
        <div
          class="flex items-center bg-white border border-[#969292]/30 rounded-xl px-6 py-[9px] text-lg font-semibold text-[#817F7F]"
        >
          Total de productos:
          <span class="ml-2 text-black font-normal">{{ totalProductos }}</span>
        </div>

        <!-- Total en dinero -->
        <div
          class="flex items-center bg-white border border-[#969292]/30 rounded-xl px-6 py-[9px] text-lg font-bold text-black"
        >
          Total:
          <span class="ml-2 text-black font-normal"
            >${{ totalCarrito.toFixed(2) }}</span
          >
        </div>

        <!-- Botón -->
        <button
          class="bg-[#00932A] text-white font-semibold px-8 py-[10px] rounded-xl text-base"
          @click="cargarStock"
          :disabled="submitting"
        >
          {{ submitting ? "Cargando..." : "Cargar Stock" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerComp from "@/components/SpinnerComp.vue";

export default {
  components: { SpinnerComp },

  data() {
    return {
      loading: true,
      submitting: false,
      unidades: [],
      selectedUnidad: "",
      productosCarrito: [],
    };
  },

  computed: {
    totalProductos() {
      return this.productosCarrito.reduce(
        (s, p) => s + Number(p.cantidad || 1),
        0,
      );
    },

    totalCarrito() {
      return this.productosCarrito.reduce(
        (s, p) => s + Number(p.precio) * Number(p.cantidad || 1),
        0,
      );
    },
  },

  methods: {
    guardarCarrito() {
      localStorage.setItem(
        "productosSeleccionados",
        JSON.stringify(this.productosCarrito),
      );
    },

    cargarCarrito() {
      try {
        const raw = localStorage.getItem("productosSeleccionados");
        if (!raw) return;

        const parsed = JSON.parse(raw);

        if (!Array.isArray(parsed)) {
          localStorage.removeItem("productosSeleccionados");
          return;
        }

        this.productosCarrito = parsed.map((p) => ({
          ...p,
          cantidad: Math.min(
            Number(p.cantidad) > 0 ? Number(p.cantidad) : 1,
            Number(p.stock) || 1,
          ),
        }));
      } catch (error) {
        console.error("Error cargando carrito:", error);
        localStorage.removeItem("productosSeleccionados");
      }
    },

    aumentarCantidad(index) {
      const p = this.productosCarrito[index];
      if (!p) return;

      if (p.cantidad < p.stock) {
        p.cantidad++;
        this.guardarCarrito();
      }
    },

    disminuirCantidad(index) {
      const p = this.productosCarrito[index];
      if (!p) return;

      if (p.cantidad > 1) {
        p.cantidad--;
        this.guardarCarrito();
      }
    },

    validarCantidad(index) {
      const p = this.productosCarrito[index];
      if (!p) return;

      let c = Number(p.cantidad);

      if (isNaN(c) || c < 1) c = 1;
      if (c > p.stock) c = p.stock;

      p.cantidad = c;
      this.guardarCarrito();
    },

    eliminarProducto(index) {
      this.productosCarrito.splice(index, 1);
      this.guardarCarrito();
    },

    async cargarStock() {
      if (this.submitting) return;

      if (!this.selectedUnidad) {
        const { notify } = require("@/utils/notify");
        notify("Selecciona una unidad", { type: 'warn' });
        return;
      }

      if (!this.productosCarrito.length) {
        const { notify } = require("@/utils/notify");
        notify("El carrito está vacío", { type: 'warn' });
        return;
      }

      this.submitting = true;

      const payload = {
        items: this.productosCarrito.map((p) => ({
          delivery_unit: this.selectedUnidad.id,
          product_id: p.id,
          stock: p.cantidad,
        })),
      };

      try {
        await this.$axios.post("/registerStorage", payload);
        const { notify } = require("@/utils/notify");
        notify("Stock cargado correctamente", { type: 'success' });
        this.productosCarrito = [];
        localStorage.removeItem("productosSeleccionados");
        this.$router.back();
      } catch (e) {
        const status = e.response?.status;
        if (status === 401) {
          const { notify } = require("@/utils/notify");
          notify("Sesión expirada", { type: 'warn' });
          this.$router.push("/login");
        } else if (status === 409) {
          const { notify } = require("@/utils/notify");
          notify("Conflicto de stock", { type: 'error' });
        } else if (status === 422) {
          const { notify } = require("@/utils/notify");
          notify("Datos inválidos", { type: 'warn' });
        } else {
          const { notify } = require("@/utils/notify");
          notify("Error inesperado", { type: 'error' });
        }
      } finally {
        this.submitting = false;
      }
    },
  },

  mounted() {
    this.cargarCarrito();

    this.$axios
      .get("/getUnitOperator")
      .then((res) => {
        this.unidades = res.data.units.map((u) => ({
          id: u.id,
          name: u.name,
          operador_name: u.operator?.user?.name,
        }));
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
input:focus {
  outline: none;
}
</style>
